import { configureStore } from "@reduxjs/toolkit";
import custumerReducer from "../context/custumerSlice";
const store = configureStore({
    reducer: {
        custumerData: custumerReducer
    }
});

export default store;